import { useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const SignupButton = ({
  className = "",
  onSignupBackgroundClick,
  toTiKhon,
  toTiKhonMinWidth,
  toTiKhonLeft,
}) => {
  const toTiKhonStyle = useMemo(() => {
    return {
      minWidth: toTiKhonMinWidth,
      left: toTiKhonLeft,
    };
  }, [toTiKhonMinWidth, toTiKhonLeft]);

  const navigate = useNavigate();

  const onSignupBackgroundClick1 = useCallback(() => {
    navigate("/31-sign-in1");
  }, [navigate]);

  return (
    <div
      className={`self-stretch flex flex-row items-start justify-start py-0 px-10 box-border max-w-full text-center text-base text-light-primary-key-background font-text-regular-lowercase ${className}`}
    >
      <div className="h-[60px] flex-1 relative max-w-full">
        <div
          className="absolute top-[0px] left-[0px] rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] w-full h-full cursor-pointer"
          onClick={onSignupBackgroundClick}
        />
        <div
          className="absolute top-[20px] left-[127px] inline-block min-w-[108px] z-[1]"
          style={toTiKhonStyle}
        >
          {toTiKhon}
        </div>
      </div>
    </div>
  );
};

SignupButton.propTypes = {
  className: PropTypes.string,
  toTiKhon: PropTypes.string,

  /** Style props */
  toTiKhonMinWidth: PropTypes.string,
  toTiKhonLeft: PropTypes.string,

  /** Action props */
  onSignupBackgroundClick: PropTypes.func,
};

export default SignupButton;
